var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"caig0040"},[_c('div',{attrs:{"data-fixed-top":"register"}},[_c('BreadcrumbsDisplay')],1),_c('main',{staticClass:"disclosure mt-40 mt-20-sm"},[_c('div',{staticClass:"container"},[_c('MessageArea'),_c('h1',{staticClass:"h1"},[_vm._v("インターネットご利用案内")]),(_vm.caig0040ViewModel.internetUsageGuideUseEnvInfo)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.CommonUtil.xssFilter(
              _vm.caig0040ViewModel.internetUsageGuideUseEnvInfo.content,
              _vm.XSSFilterOptions
            )
          )}})]):_c('div',[_c('empty-data',{staticClass:"py-60-pc py-40-sm mt-16-sm"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }